module.exports = {
	"2": 3,
	"3": 3,
	"4": 3,
	"5": 3,
	"6": 3,
	"7": 3,
	"8": 3,
	"9": 3,
	"10": 3,
	"11": 3,
	"12": 3,
	"13": 3,
	"14": 3,
	"15": 3,
	"16": 3,
	"17": 3,
	"18": 3,
	"19": 3,
	"20": 3,
	"21": 3,
	"22": 3,
	"23": 3,
	"24": 3,
	"25": 3,
	"26": 3,
	"27": 3,
	"28": 3,
	"29": 3,
	"30": 3,
	"31": 3,
	"32": 3,
	"33": 3,
	"34": 3,
	"35": 3,
	"36": 3,
	"37": 3,
	"38": 3,
	"39": 3,
	"40": 3,
	"41": 3,
	"42": 3,
	"43": 3,
	"44": 3,
	"45": 3,
	"46": 3,
	"47": 3,
	"48": 3,
	"49": 3,
	"50": 3,
	"51": 3,
	"52": 3,
	"53": 3,
	"54": 3,
	"55": 3,
	"56": 3,
	"57": 3,
	"58": 3,
	"59": 3,
	"61": 3,
	"62": 3,
	"66": 3,
	"67": 3,
	"68": 3,
	"69": 3,
	"70": 3,
	"72": 3,
	"73": 3,
	"74": 3,
	"81": 3,
	"160": 4,
	"161": 4,
	"162": 4,
	"163": 4,
	"164": 4,
	"165": 4,
	"166": 4,
	"167": 4,
	"168": 4,
	"169": 4,
	"170": 4,
	"171": 4,
	"172": 4,
	"173": 4,
	"174": 4,
	"175": 4,
	"176": 4,
	"177": 4,
	"178": 4,
	"179": 4,
	"195": 4,
	"196": 4,
	"197": 4,
	"198": 4,
	"199": 4,
	"200": 4,
	"201": 4,
	"202": 4,
	"203": 4,
	"204": 4,
	"205": 4,
	"206": 4,
	"207": 4,
	"208": 4,
	"209": 4,
	"210": 4,
	"211": 4,
	"212": 4,
	"213": 4,
	"214": 4,
	"215": 4,
	"216": 4,
	"217": 4,
	"218": 4,
	"219": 4,
	"220": 4,
	"221": 4,
	"222": 4,
	"223": 4,
	"224": 4,
	"225": 4,
	"226": 4,
	"227": 4,
	"228": 4,
	"229": 4,
	"230": 4,
	"231": 4,
	"238": 4,
	"239": 4,
	"246": 4,
	"248": 4,
	"255": 4,
	"258": 4,
	"259": 4,
	"262": 4,
	"263": 4,
	"277": 4,
	"318": 4,
	"349": 4,
	"353": 4,
	"358": 1,
	"359": 1,
	"360": 1,
	"361": 1,
	"362": 1,
	"363": 1,
	"364": 1,
	"365": 1,
	"366": 1,
	"367": 1,
	"368": 1,
	"369": 1,
	"370": 1,
	"371": 1,
	"372": 1,
	"373": 1,
	"374": 1,
	"375": 1,
	"376": 1,
	"377": 1,
	"378": 1,
	"379": 1,
	"380": 1,
	"381": 1,
	"382": 1,
	"383": 1,
	"384": 1,
	"385": 1,
	"386": 1,
	"387": 1,
	"388": 1,
	"389": 1,
	"390": 1,
	"391": 1,
	"392": 1,
	"393": 1,
	"394": 1,
	"395": 1,
	"396": 1,
	"397": 1,
	"398": 1,
	"399": 1,
	"400": 1,
	"401": 1,
	"402": 1,
	"403": 1,
	"650": 2,
	"651": 2,
	"652": 2,
	"653": 2,
	"654": 2,
	"655": 2,
	"656": 2,
	"657": 2,
	"658": 2,
	"659": 2,
	"661": 1,
	"662": 1,
	"663": 1,
	"664": 1,
	"665": 1,
	"666": 1,
	"667": 1,
	"668": 1,
	"669": 1,
	"670": 1,
	"671": 1,
	"672": 1,
	"673": 1,
	"674": 1,
	"675": 1,
	"676": 1,
	"677": 1,
	"678": 1,
	"679": 1,
	"680": 1,
	"681": 1,
	"682": 1,
	"684": 1,
	"685": 1,
	"689": 1,
	"690": 1,
	"691": 1,
	"692": 1,
	"693": 1,
	"695": 1,
	"698": 1,
	"699": 1,
	"939": 3
};


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/grid-control/components/header-outcome-place-config.json
// module id = 1825
// module chunks = 2